import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getActualDate = (state: StateScheme) => {
    return state.updateDate.actual_date
}
